export default {
  demoDemographics: {
    title: 'Demographics', // datasource !== 10 or datasource !== 200 Demographic Options
    demoType: 'demoDemographics',
    access: true,
    video: 'https://vimeo.com/408422898/'
  },
  businessType: {
    title: 'Business Type',
    demoType: 'businessType',
    access: true,
    video: ''
  },
  intrestsPurchasing: {
    title: 'Interests & Purchasing',
    demoType: 'intrestsPurchasing',
    access: true,
    video: 'https://vimeo.com/408871974/'
  },
  audiencePropensities: {
    title: 'Audience Propensities',
    demoType: 'audiencePropensities',
    access: true,
    video: 'https://vimeo.com/411034266/'
  },
  quickPicks: {
    title: 'Quick Picks',
    demoType: 'quickPicks',
    access: true,
    video: ''
  },
  businessQuickPicks: {
    title: 'Business Quick Picks',
    demoType: 'businessQuickPicks',
    access: true,
    video: ''
  },
  suppression: {
    title: 'Suppression',
    demoType: 'suppression',
    access: true,
    video: 'https://vimeo.com/411103920/'
  },
  search: {
    title: 'Search',
    demoType: 'search',
    access: true,
    video: ''
  },
  residentOccupantList: {
    title: 'Resident Occupant Lists',
    demoType: 'residentOccupantList',
    access: true,
    video: ''
  }
}



// WEBPACK FOOTER //
// ./src/config/demoType.js